import React, { useState, useEffect } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(styles);
export default function SweetAlertCustom(props) {
  const classes = useStyles();
  const [alert, setAlert] = useState(null);
  const { openAlert, setOpenAlert } = props;

  const hideAlert = () => {
    setAlert(null);
  };

  function confirmAlert() {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={openAlert.title}
        onConfirm={() => {
          props.confirm();
          setOpenAlert({ open: false });
          hideAlert();
        }}
        onCancel={() => {
          if (props.rejected) {
            props.rejected();
          }
          setOpenAlert({ open: false });
          hideAlert();
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  useEffect(() => {
    if (openAlert.open && openAlert.type === 'confirm') {
      confirmAlert();
    }
  }, [openAlert.open, openAlert.type]);

  return <>{alert}</>;
}
